/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './dvsn-form-builder-submission-detail.html.twig';
import './dvsn-form-builder-submission-detail.scss';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('dvsn-form-builder-submission-detail', {
    template,

    inject: [
        'repositoryFactory'
    ],

    mixins: [
        Mixin.getByName('placeholder'),
        Mixin.getByName('notification')
    ],

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    data() {
        return {
            submission: null,
            isLoading: false
        };
    },

    created() {
        this.getSubmission();
    },

    computed: {
        elements() {
            if (!this.submission) {
                return [];
            }

            return this.submission.payload;
        },

        repository() {
            return this.repositoryFactory.create('dvsn_form_builder_submission');
        },

        criteria() {
            const criteria = new Criteria();
            return criteria;
        }
    },

    methods: {
        getValue(element) {
            if (element.type === 'firstname-lastname' || element.type === 'email-phone') {
                return element.value.replace('|', '<br />');
            }

            return element.value.replace(/\r\n|\n\r|\r|\n/g, '<br />');
        },

        getSubmission() {
            this.isLoading = true;
            this.repository
                .get(this.$route.params.id, Shopware.Context.api, this.criteria)
                .then((entity) => {
                    this.submission = entity;
                    this.isLoading = false;
                });
        },
    }
});
